module.exports = __webpack_public_path__ + "static/media/hiw17.cee1650a.svg";